"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRelicUserType = exports.getRelicConsent = exports.getRelicActionName = exports.addRelicAnalyticsPageAction = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _constants = require("../constants");

/**
 * @name addRelicAnalyticsPageAction
 * @description - Reports event along with a name and optional attributes
 * @param {string | undefined} name - Event name
 * @param {object} args - Event data object
 * @returns {void}
 */
var addRelicAnalyticsPageAction = function addRelicAnalyticsPageAction(name, args) {
  try {
    var _window$newrelic;

    // name is a required field for this New Relic function, if we don't have it,
    // then don't even attempt to hit the New Relic library.
    if (!name) return;
    if ((_window$newrelic = window.newrelic) !== null && _window$newrelic !== void 0 && _window$newrelic.addPageAction) window.newrelic.addPageAction(name, args);
    /* eslint-disable no-empty */
  } catch (err) {}
};
/**
 * @name getRelicUserType
 * @description - Returns user type for Relic events
 * @param {boolean} isLoggedIn - Is user logged in boolean
 * @returns {string}
 */


exports.addRelicAnalyticsPageAction = addRelicAnalyticsPageAction;

var getRelicUserType = function getRelicUserType(isLoggedIn) {
  return isLoggedIn ? 'member' : 'guest';
};
/**
 * @name getRelicConsent
 * @description - Returns consent from Cookies for Relic events
 * @returns {string}
 */


exports.getRelicUserType = getRelicUserType;

var getRelicConsent = function getRelicConsent() {
  return _jsCookie.default.get('ni_c') || '';
};
/**
 * @name getRelicActionName
 * @description - Returns Relic event name based on event type
 * @param {string | undefined} actionType - Action type for the event that happened
 * @returns {string | undefined}
 */


exports.getRelicConsent = getRelicConsent;

var getRelicActionName = function getRelicActionName(actionType) {
  switch (actionType) {
    case _constants.RELIC_ACTION_TYPES_NAME.SETTINGS_PAGE_VIEWED:
      return _constants.RELIC_EVENT_NAME.PRIVACY_SETTINGS_VIEWED;

    case _constants.RELIC_ACTION_TYPES_NAME.ACCEPT_ALL_CLICKED:
      return _constants.RELIC_EVENT_NAME.PRIVACY_SETTINGS_ACCEPT_ALL;

    case _constants.RELIC_ACTION_TYPES_NAME.DECLINE_ALL_CLICKED:
      return _constants.RELIC_EVENT_NAME.PRIVACY_SETTINGS_DECLINE_ALL;

    case _constants.RELIC_ACTION_TYPES_NAME.CONFIRM_CHOICE_CLICKED:
      return _constants.RELIC_EVENT_NAME.PRIVACY_SETTINGS_CONFIRM_CHOICES;

    case _constants.RELIC_ACTION_TYPES_NAME.GPC_ENABLED:
      return _constants.RELIC_EVENT_NAME.GPC_ENABLED;

    default:
      return undefined;
  }
};

exports.getRelicActionName = getRelicActionName;